import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { apiPost } from "@/config";

const ComposeEmail = ({ subscriberCount, onBack }) => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!window.confirm(`Send this email to ${subscriberCount} subscriber(s)?`)) return;
    setSending(true);
    setResult(null);
    try {
      const { data } = await apiPost("/email-subscribers", { subject, body });
      setResult({ type: "success", message: data.message });
      setSubject("");
      setBody("");
    } catch (err) {
      setResult({ type: "error", message: err.response?.data?.detail || "Failed to send" });
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={handleSend} className="p-4 space-y-4">
      <button type="button" onClick={onBack} className="text-blue-400 hover:text-blue-300 text-sm flex items-center gap-1">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
        Back to subscribers
      </button>
      {result && (
        <div className={`px-4 py-3 rounded-lg text-sm ${result.type === "error" ? "bg-red-500/20 border border-red-500 text-red-400" : "bg-green-500/20 border border-green-500 text-green-400"}`}>
          {result.message}
        </div>
      )}
      <div className="space-y-2">
        <Label className="text-slate-300">Subject</Label>
        <Input data-testid="email-subject-input" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="New article published!" className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500" required />
      </div>
      <div className="space-y-2">
        <Label className="text-slate-300">Message</Label>
        <Textarea data-testid="email-body-input" value={body} onChange={(e) => setBody(e.target.value)} placeholder="Hi! We've just published a new article..." className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500 min-h-[150px]" required />
      </div>
      <p className="text-slate-500 text-xs">Sending from ukdiscovered@gmail.com to {subscriberCount} subscriber(s)</p>
      <Button data-testid="send-email-button" type="submit" disabled={sending} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium">
        {sending ? "Sending..." : `Send to ${subscriberCount} subscriber(s)`}
      </Button>
    </form>
  );
};

export default ComposeEmail;
